<template>
  <div>
    <template v-for="(item, index) in tableData">
      <push-list-item
        :key="index"
        :data="item"
        :action="actionUrl"
        :retype="type"
        v-czc="[mdData.category, mdData.action, mdData.label, index + 1, mdData.nodeid]"
        :visitlocation="visitlocation"
      >
      </push-list-item>
    </template>

    <empty-list v-if="!tableData.length"></empty-list>
  </div>
</template>

<script>
import EmptyList from "@components/sys/empty-list";

import pushListItem from "../components/push-list-item";

export default {
  components: {
    pushListItem,
    EmptyList,
  },
  props: {
    mdData: {
      type: Object,
      default: () => {
        return {
          category: "",
          action: "",
          label: "",
          nodeid: "",
        };
      },
    },
    action: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    visitlocation: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableData: [],
      actionUrl: "",
    };
  },
  methods: {
    queryData() {
      if (this.type == "information") {
        //政策法规
        this.actionUrl = `${this.$store.state.api.baseWebUrl}/yzkj/information/detail`;
      }
      if (this.type == "standard") {
        //标准规范
        this.actionUrl = `${this.$store.state.api.baseWebUrl}/yzkj/standard/detail`;
      }
      this.$get(
        `${this.$store.state.api.baseWebUrl}${this.action}`,
        {
          withoutToken: "true",
          pageIndex: "1",
          pageSize: "10",
        },
        (data) => {
          this.tableData = data.records || [];
        }
      );
    },
  },
  mounted() {
    this.queryData();
  },
};
</script>

<style lang="scss" scoped></style>
